import { Text } from '@chakra-ui/react'

export const SbpPaymentBadge = () => (
  <Text
    as="span"
    fontWeight="bold"
    textTransform="uppercase"
    px="3px"
    py="1px"
    mt="-16px"
    mx="-7px"
  >
    СБП
  </Text>
)
